<template>
  <div class="button-container">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'ButtonContainer',
};
</script>
<style scoped lang="scss">
.button-container {
  width: 100%;
  max-width: 400px;
  margin-top: 26px;
  display: flex;
  justify-content: center;

  button {
    margin: 0 10px;
  }
}
</style>
